//= ========================================================================
import React from 'react';
import { View } from 'react-native-web';
import FullPageSimulator from '../../FullPageSimulator';
import SourceCard from '../../../AuxiliaryComponent/MixComponent/SourceCard';

const SelectSourceFP = ({
  globJSON,
  simPlatform,
  headlineText,
}) => (
  <FullPageSimulator
    globJSON={globJSON}
    simPlatform={simPlatform}
    headlineText={headlineText}
  >
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', paddingHorizontal: 15 }}>
      <SourceCard globJSON={globJSON} isBlueBorder />
      <SourceCard globJSON={globJSON} />
      <SourceCard globJSON={globJSON} />
    </View>
  </FullPageSimulator>
);

export default SelectSourceFP;
